import { render, staticRenderFns } from "./edit-user-form.vue?vue&type=template&id=4dd6e98a&"
import script from "./edit-user-form.vue?vue&type=script&lang=js&"
export * from "./edit-user-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports